<template>
  <div class="table-responsive">
    <h4 class="service-response-h4">
      {{ $t("message.contragent_search.annual_report") }}
    </h4>
    <div
      v-for="(result, index) in results"
      :key="'res-an-rep-' + index"
      class="result-block mb-3"
    >
      <div>
        <!-- <div class="row">
                                            <div class="col-6"><h5>{{result.basic_info.CompanyName}}</h5></div>
                                            <div class="col-6 text-right">
                                                {{result.basic_info.RegNo}}
                                            </div>
                                        </div>
                                        <hr> -->
        <div class="service-response-h4" v-if="mode != 'pdf'">
          {{ $t("message.contragent_search.BasicInfo") }}
        </div>
        <!-- <h5   class="service-response-h4"></h5> -->
        <div>
          <div v-if="mode !== 'pdf'">
            <b-table
              :fixed="true"
              :fields="basic_info_fields"
              :items="resultsData(result, 'BasicInfoData')"
            ></b-table>
          </div>
          <div v-if="mode == 'pdf'">
            <b-table
              :fixed="true"
              :fields="basic_info_fields_pdf[0]"
              :items="resultsData(result, 'BasicInfoData')"
            ></b-table>
            <br />
            <b-table
              :fixed="true"
              :fields="basic_info_fields_pdf[1]"
              :items="resultsData(result, 'BasicInfoData')"
            ></b-table>
            <br />
            <b-table
              :fixed="true"
              :fields="basic_info_fields_pdf[2]"
              :items="resultsData(result, 'BasicInfoData')"
            ></b-table>
            <br />
            <b-table
              :fixed="true"
              :fields="basic_info_fields_pdf[3]"
              :items="resultsData(result, 'BasicInfoData')"
            ></b-table>
          </div>
        </div>
        <h5 class="service-response-h4">
          {{ $t("message.contragent_search.AssetsData") }}
        </h5>
        <div>
          <div v-if="mode != 'pdf'">
            <b-table
              :fixed="true"
              :fields="assets_data_fields"
              :items="resultsData(result, 'AssetsData')"
            ></b-table>
          </div>
          <div v-if="mode == 'pdf'">
            <b-table
              :fixed="true"
              :fields="assets_data_fields_pdf[0]"
              :items="resultsData(result, 'AssetsData')"
            ></b-table>
            <br />
            <b-table
              :fixed="true"
              :fields="assets_data_fields_pdf[1]"
              :items="resultsData(result, 'AssetsData')"
            ></b-table>
          </div>
        </div>
        <h5 class="service-response-h4">
          {{ $t("message.contragent_search.ChangeList") }}
        </h5>
        <div>
          <div class="table-responsive">
            <b-table
              :fields="change_fields"
              :items="resultsDataList(result, 'ChangeList')"
            ></b-table>
          </div>
        </div>
        <h5 class="service-response-h4">
          {{ $t("message.contragent_search.InvestInfoList") }}
        </h5>
        <div>
          <div class="table-responsive">
            <b-table
              :fields="invest_info_fields"
              :items="resultsDataList(result, 'InvestInfoList')"
            ></b-table>
          </div>
        </div>
        <h5 class="service-response-h4">
          {{ $t("message.contragent_search.PartnerList") }}
        </h5>
        <div>
          <div class="table-responsive">
            <b-table
              :fields="partner_fields"
              :items="resultsDataList(result, 'PartnerList')"
            ></b-table>
          </div>
        </div>
        <h5 class="service-response-h4">
          {{ $t("message.contragent_search.ProvideAssuranceList") }}
        </h5>
        <div>
          <div class="table-responsive">
            <b-table
              :fields="provide_assurance_fields"
              :items="resultsDataList(result, 'ProvideAssuranceList')"
            ></b-table>
          </div>
        </div>
        <h5 class="service-response-h4">
          {{ $t("message.contragent_search.StockChangeList") }}
        </h5>
        <div>
          <div class="table-responsive">
            <b-table
              :fields="stock_change_fields"
              :items="resultsDataList(result, 'StockChangeList')"
            ></b-table>
          </div>
        </div>
        <h5 class="service-response-h4">
          {{ $t("message.contragent_search.WebSiteList") }}
        </h5>
        <div>
          <div class="table-responsive">
            <b-table
              :fields="website_fields"
              :items="resultsDataList(result, 'WebSiteList')"
            >
              <template v-slot:cell(WebSite)="data">
                <a :href="data.value">{{ data.value }}</a>
              </template>
            </b-table>
          </div>
        </div>
        <h5 class="service-response-h4">
          {{ $t("message.contragent_search.AdministrationLicenseList") }}
        </h5>
        <div>
          <div class="table-responsive">
            <b-table
              :fields="administration_license_fields"
              :items="resultsDataList(result, 'AdministrationLicenseList')"
            ></b-table>
          </div>
        </div>
        <!-- <h5 class="service-response-h4">
          {{ $t("message.contragent_search.BranchList") }}
        </h5>
        <div>
          <div class="table-responsive">
            <b-table
              :fields="branch_fields"
              :items="resultsDataList(result, 'BranchList')"
            ></b-table>
          </div>
        </div>
        <h5 class="service-response-h4">
          {{ $t("message.contragent_search.EmployeeList") }}
        </h5>
        <div>
          <div class="table-responsive">
            <b-table
              :fields="employee_fields"
              :items="resultsDataList(result, 'EmployeeList')"
            ></b-table>
          </div>
        </div> -->
        <h5 class="service-response-h4">
          {{ $t("message.contragent_search.SocialInsurance") }}
        </h5>
        <div>
          <div v-if="mode != 'pdf'">
            <b-table
              :fixed="true"
              :fields="social_insurance_fields"
              :items="resultsData(result, 'SocialInsurance')"
            ></b-table>
          </div>
          <div v-if="mode == 'pdf'">
            <b-table
              :fixed="true"
              :fields="social_insurance_fields_pdf[0]"
              :items="resultsData(result, 'SocialInsurance')"
            ></b-table>
            <br />
            <b-table
              :fixed="true"
              :fields="social_insurance_fields_pdf[1]"
              :items="resultsData(result, 'SocialInsurance')"
            ></b-table>
            <br />
            <b-table
              :fixed="true"
              :fields="social_insurance_fields_pdf[2]"
              :items="resultsData(result, 'SocialInsurance')"
            ></b-table>
            <br />
            <b-table
              :fixed="true"
              :fields="social_insurance_fields_pdf[3]"
              :items="resultsData(result, 'SocialInsurance')"
            ></b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["data", "mode"],
  data() {
    return {
      search_complete: false,
      loading: false,
      keyword: "",
      results: {},
      basic_info_fields: [
        {
          key: "RegNo",
          label: this.$t("message.contragent_search.RegNo"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "CompanyName",
          label: this.$t("message.contragent_search.CompanyName"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "CreditCode",
          label: this.$t("message.contragent_search.CreditCode"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "OperatorName",
          label: this.$t("message.contragent_search.OperatorName"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "ContactNo",
          label: this.$t("message.contragent_search.ContactNo"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "PostCode",
          label: this.$t("message.contragent_search.PostCode"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "Address",
          label: this.$t("message.contragent_search.Address"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "EmailAddress",
          label: this.$t("message.contragent_search.EmailAddress"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "IsStockRightTransfer",
          label: this.$t("message.contragent_search.IsStockRightTransfer"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "Status",
          label: this.$t("message.contragent_search.Status"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "HasWebSite",
          label: this.$t("message.contragent_search.HasWebSite"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "HasNewStockOrByStock",
          label: this.$t("message.contragent_search.HasNewStockOrByStock"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "EmployeeCount",
          label: this.$t("message.contragent_search.EmployeeCount"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "BelongTo",
          label: this.$t("message.contragent_search.BelongTo"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "CapitalAmount",
          label: this.$t("message.contragent_search.CapitalAmount"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "HasProvideAssurance",
          label: this.$t("message.contragent_search.HasProvideAssurance"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "OperationPlaces",
          label: this.$t("message.contragent_search.OperationPlaces"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "MainType",
          label: this.$t("message.contragent_search.MainType"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "OperationDuration",
          label: this.$t("message.contragent_search.OperationDuration"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "IfContentSame",
          label: this.$t("message.contragent_search.IfContentSame"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "DifferentContent",
          label: this.$t("message.contragent_search.DifferentContent"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "GeneralOperationItem",
          label: this.$t("message.contragent_search.GeneralOperationItem"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "ApprovedOperationItem",
          label: this.$t("message.contragent_search.ApprovedOperationItem"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
      ],
      basic_info_fields_pdf: [
        [
          {
            key: "RegNo",
            label: this.$t("message.contragent_search.RegNo"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "CompanyName",
            label: this.$t("message.contragent_search.CompanyName"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "CreditCode",
            label: this.$t("message.contragent_search.CreditCode"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "OperatorName",
            label: this.$t("message.contragent_search.OperatorName"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "ContactNo",
            label: this.$t("message.contragent_search.ContactNo"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "PostCode",
            label: this.$t("message.contragent_search.PostCode"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
        ],
        [
          {
            key: "Address",
            label: this.$t("message.contragent_search.Address"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "EmailAddress",
            label: this.$t("message.contragent_search.EmailAddress"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "IsStockRightTransfer",
            label: this.$t("message.contragent_search.IsStockRightTransfer"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "Status",
            label: this.$t("message.contragent_search.Status"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "HasWebSite",
            label: this.$t("message.contragent_search.HasWebSite"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "HasNewStockOrByStock",
            label: this.$t("message.contragent_search.HasNewStockOrByStock"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
        ],
        [
          {
            key: "EmployeeCount",
            label: this.$t("message.contragent_search.EmployeeCount"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "BelongTo",
            label: this.$t("message.contragent_search.BelongTo"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "CapitalAmount",
            label: this.$t("message.contragent_search.CapitalAmount"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "HasProvideAssurance",
            label: this.$t("message.contragent_search.HasProvideAssurance"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "OperationPlaces",
            label: this.$t("message.contragent_search.OperationPlaces"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "MainType",
            label: this.$t("message.contragent_search.MainType"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
        ],
        [
          {
            key: "OperationDuration",
            label: this.$t("message.contragent_search.OperationDuration"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "IfContentSame",
            label: this.$t("message.contragent_search.IfContentSame"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "DifferentContent",
            label: this.$t("message.contragent_search.DifferentContent"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "GeneralOperationItem",
            label: this.$t("message.contragent_search.GeneralOperationItem"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "ApprovedOperationItem",
            label: this.$t("message.contragent_search.ApprovedOperationItem"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
        ],
      ],
      change_fields: [
        {
          key: "No",
          label: this.$t("message.contragent_search.No"),
        },
        {
          key: "ChangeName",
          label: this.$t("message.contragent_search.ChangeName"),
        },
        {
          key: "Before",
          label: this.$t("message.contragent_search.Before"),
        },
        {
          key: "After",
          label: this.$t("message.contragent_search.After"),
        },
        {
          key: "ChangeDate",
          label: this.$t("message.contragent_search.ChangeDate"),
        },
      ],
      partner_fields: [
        { key: "No", label: this.$t("message.contragent_search.No") },
        { key: "Name", label: this.$t("message.contragent_search.Name") },
        {
          key: "ShouldCapi",
          label: this.$t("message.contragent_search.ShouldCapi"),
        },
        {
          key: "ShouldDate",
          label: this.$t("message.contragent_search.ShouldDate"),
        },
        {
          key: "ShouldType",
          label: this.$t("message.contragent_search.ShouldType"),
        },
        {
          key: "RealCapi",
          label: this.$t("message.contragent_search.RealCapi"),
        },
        {
          key: "RealDate",
          label: this.$t("message.contragent_search.RealDate"),
        },
        {
          key: "RealType",
          label: this.$t("message.contragent_search.RealType"),
        },
        { key: "Form", label: this.$t("message.contragent_search.Form") },
        {
          key: "InvestmentRatio",
          label: this.$t("message.contragent_search.InvestmentRatio"),
        },
      ],
      invest_info_fields: [
        { key: "No", label: this.$t("message.contragent_search.No") },
        { key: "Name", label: this.$t("message.contragent_search.Name") },
        {
          key: "NameTranslated",
          label: this.$t("message.contragent_search.Name"),
        },
        { key: "RegNo", label: this.$t("message.contragent_search.RegNo") },
        {
          key: "ShouldCapi",
          label: this.$t("message.contragent_search.ShouldCapi"),
        },
        {
          key: "ShareholdingRatio",
          label: this.$t("message.contragent_search.ShareholdingRatio"),
        },
      ],
      provide_assurance_fields: [
        { key: "No", label: this.$t("message.contragent_search.No") },
        {
          key: "Creditor",
          label: this.$t("message.contragent_search.Creditor"),
        },
        { key: "Debtor", label: this.$t("message.contragent_search.Debtor") },
        {
          key: "CreditorCategory",
          label: this.$t("message.contragent_search.CreditorCategory"),
        },
        {
          key: "CreditorAmount",
          label: this.$t("message.contragent_search.CreditorAmount"),
        },
        {
          key: "FulfillObligation",
          label: this.$t("message.contragent_search.FulfillObligation"),
        },
        {
          key: "AssuranceDurn",
          label: this.$t("message.contragent_search.AssuranceDurn"),
        },
        {
          key: "AssuranceType",
          label: this.$t("message.contragent_search.AssuranceType"),
        },
        {
          key: "AssuranceScope",
          label: this.$t("message.contragent_search.AssuranceScope"),
        },
      ],
      stock_change_fields: [
        { key: "No", label: this.$t("message.contragent_search.No") },
        { key: "Name", label: this.$t("message.contragent_search.Name") },
        { key: "Before", label: this.$t("message.contragent_search.Before") },
        { key: "After", label: this.$t("message.contragent_search.After") },
        {
          key: "ChangeDate",
          label: this.$t("message.contragent_search.ChangeDate"),
        },
      ],
      website_fields: [
        { key: "No", label: this.$t("message.contragent_search.No") },
        { key: "Type", label: this.$t("message.contragent_search.Type") },
        { key: "Name", label: this.$t("message.contragent_search.Name") },
        { key: "WebSite", label: this.$t("message.contragent_search.WebSite") },
      ],
      administration_license_fields: [
        { key: "No", label: this.$t("message.contragent_search.No") },
        { key: "Name", label: this.$t("message.contragent_search.Name") },
        { key: "EndDate", label: this.$t("message.contragent_search.EndDate") },
      ],
      branch_fields: [
        { key: "Name", label: this.$t("message.contragent_search.Name") },
        { key: "RegNo", label: this.$t("message.contragent_search.RegNo") },
        { key: "Address", label: this.$t("message.contragent_search.Address") },
        {
          key: "principal",
          label: this.$t("message.contragent_search.principal"),
        },
      ],
      employee_fields: [
        { key: "Name", label: this.$t("message.contragent_search.Name") },
        { key: "Job", label: this.$t("message.contragent_search.Job") },
        { key: "CerNo", label: this.$t("message.contragent_search.CerNo") },
        {
          key: "ScertName",
          label: this.$t("message.contragent_search.ScertName"),
        },
      ],
      assets_data_fields: [
        {
          key: "No",
          label: this.$t("message.contragent_search.No"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "Year",
          label: this.$t("message.contragent_search.Year"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "PublishDate",
          label: this.$t("message.contragent_search.PublishDate"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "TotalAssets",
          label: this.$t("message.contragent_search.TotalAssets"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "TotalOwnersEquity",
          label: this.$t("message.contragent_search.TotalOwnersEquity"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "GrossTradingIncome",
          label: this.$t("message.contragent_search.GrossTradingIncome"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "MainBusinessIncome",
          label: this.$t("message.contragent_search.MainBusinessIncome"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "NetProfit",
          label: this.$t("message.contragent_search.NetProfit"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "TotalTaxAmount",
          label: this.$t("message.contragent_search.TotalTaxAmount"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "TotalLiabilities",
          label: this.$t("message.contragent_search.TotalLiabilities"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "BankingCredit",
          label: this.$t("message.contragent_search.BankingCredit"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "GovernmentSubsidy",
          label: this.$t("message.contragent_search.GovernmentSubsidy"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
      ],
      assets_data_fields_pdf: [
        [
          {
            key: "No",
            label: this.$t("message.contragent_search.No"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "Year",
            label: this.$t("message.contragent_search.Year"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "PublishDate",
            label: this.$t("message.contragent_search.PublishDate"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "TotalAssets",
            label: this.$t("message.contragent_search.TotalAssets"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "TotalOwnersEquity",
            label: this.$t("message.contragent_search.TotalOwnersEquity"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "GrossTradingIncome",
            label: this.$t("message.contragent_search.GrossTradingIncome"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
        ],
        [
          {
            key: "MainBusinessIncome",
            label: this.$t("message.contragent_search.MainBusinessIncome"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "NetProfit",
            label: this.$t("message.contragent_search.NetProfit"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "TotalTaxAmount",
            label: this.$t("message.contragent_search.TotalTaxAmount"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "TotalLiabilities",
            label: this.$t("message.contragent_search.TotalLiabilities"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "BankingCredit",
            label: this.$t("message.contragent_search.BankingCredit"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "GovernmentSubsidy",
            label: this.$t("message.contragent_search.GovernmentSubsidy"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
        ],
      ],
      social_insurance_fields: [
        {
          key: "No",
          label: this.$t("message.contragent_search.No"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "Year",
          label: this.$t("message.contragent_search.Year"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "PublishDate",
          label: this.$t("message.contragent_search.PublishDate"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "UrbanBasicIns",
          label: this.$t("message.contragent_search.UrbanBasicIns"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "EmployeeBasicIns",
          label: this.$t("message.contragent_search.EmployeeBasicIns"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "MaternityIns",
          label: this.$t("message.contragent_search.MaternityIns"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "UnemploymentIns",
          label: this.$t("message.contragent_search.UnemploymentIns"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "IndustrialInjuryIns",
          label: this.$t("message.contragent_search.IndustrialInjuryIns"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "EntUrbanBasicInsNum",
          label: this.$t("message.contragent_search.EntUrbanBasicInsNum"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "EntUnemploymentInsNum",
          label: this.$t("message.contragent_search.EntUnemploymentInsNum"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "EntEmployeeBasicInsNum",
          label: this.$t("message.contragent_search.EntEmployeeBasicInsNum"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "EntIndustrialInjuryInsNum",
          label: this.$t("message.contragent_search.EntIndustrialInjuryInsNum"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "EntMaternityInsNum",
          label: this.$t("message.contragent_search.EntMaternityInsNum"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "ActUrbanBasicInsAmount",
          label: this.$t("message.contragent_search.ActUrbanBasicInsAmount"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "ActUnemploymentInsAmount",
          label: this.$t("message.contragent_search.ActUnemploymentInsAmount"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "ActEmployeeBasicInsAmount",
          label: this.$t("message.contragent_search.ActEmployeeBasicInsAmount"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "ActIndustrialInjuryInsAmount",
          label: this.$t(
            "message.contragent_search.ActIndustrialInjuryInsAmount",
          ),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "ActMaternityInsAmount",
          label: this.$t("message.contragent_search.ActMaternityInsAmount"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "OweUrbanBasicInsAmount",
          label: this.$t("message.contragent_search.OweUrbanBasicInsAmount"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "OweUnemploymentInsAmount",
          label: this.$t("message.contragent_search.OweUnemploymentInsAmount"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "OweIndustrialInjuryInsAmount",
          label: this.$t(
            "message.contragent_search.OweIndustrialInjuryInsAmount",
          ),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
        {
          key: "OweMaternityInsAmount",
          label: this.$t("message.contragent_search.OweMaternityInsAmount"),
          thClass: "row-grid",
          tdClass: "row-grid",
        },
      ],
      social_insurance_fields_pdf: [
        [
          {
            key: "No",
            label: this.$t("message.contragent_search.No"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "Year",
            label: this.$t("message.contragent_search.Year"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "PublishDate",
            label: this.$t("message.contragent_search.PublishDate"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "UrbanBasicIns",
            label: this.$t("message.contragent_search.UrbanBasicIns"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "EmployeeBasicIns",
            label: this.$t("message.contragent_search.EmployeeBasicIns"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "MaternityIns",
            label: this.$t("message.contragent_search.MaternityIns"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
        ],
        [
          {
            key: "UnemploymentIns",
            label: this.$t("message.contragent_search.UnemploymentIns"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "IndustrialInjuryIns",
            label: this.$t("message.contragent_search.IndustrialInjuryIns"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "EntUrbanBasicInsNum",
            label: this.$t("message.contragent_search.EntUrbanBasicInsNum"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "EntUnemploymentInsNum",
            label: this.$t("message.contragent_search.EntUnemploymentInsNum"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "EntEmployeeBasicInsNum",
            label: this.$t("message.contragent_search.EntEmployeeBasicInsNum"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "EntIndustrialInjuryInsNum",
            label: this.$t(
              "message.contragent_search.EntIndustrialInjuryInsNum",
            ),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
        ],
        [
          {
            key: "EntMaternityInsNum",
            label: this.$t("message.contragent_search.EntMaternityInsNum"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "ActUrbanBasicInsAmount",
            label: this.$t("message.contragent_search.ActUrbanBasicInsAmount"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "ActUnemploymentInsAmount",
            label: this.$t(
              "message.contragent_search.ActUnemploymentInsAmount",
            ),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "ActEmployeeBasicInsAmount",
            label: this.$t(
              "message.contragent_search.ActEmployeeBasicInsAmount",
            ),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "ActIndustrialInjuryInsAmount",
            label: this.$t(
              "message.contragent_search.ActIndustrialInjuryInsAmount",
            ),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "ActMaternityInsAmount",
            label: this.$t("message.contragent_search.ActMaternityInsAmount"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
        ],
        [
          {
            key: "OweUrbanBasicInsAmount",
            label: this.$t("message.contragent_search.OweUrbanBasicInsAmount"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "OweUnemploymentInsAmount",
            label: this.$t(
              "message.contragent_search.OweUnemploymentInsAmount",
            ),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "OweIndustrialInjuryInsAmount",
            label: this.$t(
              "message.contragent_search.OweIndustrialInjuryInsAmount",
            ),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
          {
            key: "OweMaternityInsAmount",
            label: this.$t("message.contragent_search.OweMaternityInsAmount"),
            thClass: "row-grid",
            tdClass: "row-grid",
          },
        ],
      ],
    };
  },
  methods: {
    async groupResults(results) {
      await results.forEach(async (result) => {
        if (
          Object.keys(this.results).indexOf(result.BasicInfoData.RegNo) == -1
        ) {
          console.log("results");
          console.log(this.results);
          //add new company
          this.results[result.BasicInfoData.RegNo] = {
            basic_info: result.BasicInfoData,
            results: [result],
          };
        } else {
          //add result to existing company
          this.results[result.BasicInfoData.RegNo].results.push(result);
          console.log("results else");
          console.log(this.results);
        }
      });
    },
    /**
     * Gets array of data-fields from the array of Results for the fields, that are arrays of objects
     * @param {Array} result – result record for company with list of results
     * @param {String} field - field to get array of
     */
    resultsDataList(result, field) {
      const results = [];
      console.log(result, field);
      result.results.forEach((result_) => {
        if (
          typeof result_[field][0] !== "undefined" &&
          typeof result_[field] !== "string"
        )
          result_[field].forEach((item) => {
            results.push(item);
          });
      });
      return results;
    },
    /**
     * Gets array of data-fields from the array of Results
     * @param {Array} result – result record for company with list of results
     * @param {String} field - field to get array of
     */
    resultsData(result, field) {
      return result.results.map((result_) => {
        // const res = {}
        // result_[field].map(data=>{
        //     res[data.Original.Key] = data.translated
        // })
        // res.Year = result_
        return result_[field]; //{...result_[field], Year: result_.Year, PublishDate: result_.PublishDate, No: result_.No}
      });
    },
    rowClass(item, type) {
      //if (!item || type !== 'row') return
      return "row-grid";
    },
  },
  mounted() {
    console.log("annual mounted", this.data);
    //this.groupResults(this.data);
    this.results = this.data;
  },
  watch: {
    data: function (newVal, oldVal) {
      //this.groupResults(newVal)
      this.results = newVal;
    },
  },
};
</script>
<style>
.row-grid {
  font-size: 10px;
  padding: 4px !important;
  word-wrap: break-word;
}
</style>
